module.exports = __webpack_public_path__ + "static/carlsbad-9-35f81dbed9ba115ee48d5921fe5dd5bd.png";